import { AppShell } from "@mantine/core";
import { Header } from "./Header";
import useTranslation from "../hooks/useTranslation";
import { FooterLinks } from "./Footer";
// const user = {
//   name: "",
//   image: <IconBell size={40} />,
// };
// const Tabs = ["דו''ח ביצועים", "דף העסק", "שירותים", "לקוחות", "פגישות" , "יומן", "צוות", "רכישת מנוי"]

export const ApplicationContainer = ({ children }) => {
  const { t } = useTranslation();
  return (
    <div dir={t("Direction")}>
      <AppShell header={{ height: 48 }}>
        <AppShell.Header zIndex={100}>{Header()}</AppShell.Header>
        <AppShell.Main>{children}</AppShell.Main>
        <AppShell.Footer style={{position: "static"}}>{FooterLinks()}</AppShell.Footer>
      </AppShell>
    </div>
  );
};

{
  /* <AppShell
styles={{
  main: {
    background: "#FFFFFF",
    width: "100vh",
    height: "100vh",
  },
}}
fixed
>
{children}
</AppShell> */
}
